import React from "react";
import AttendanceItem from "./AttendanceItem";
import { CalendarEmptyIcon } from "./Icons";


export default function AttendanceList({ records, loading, refreshing, error, monthName, year, onRefresh }) {
//  console.log("attendance list",records)

  if (loading) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-3 bg-gray-50">
        {/* Simple CSS spinner — no extra library needed */}
        <div className="w-10 h-10 rounded-full border-4 border-gray-200 border-t-[#FDC700] animate-spin" />
        <span className="text-sm text-gray-400">Loading attendance…</span>
      </div>
    );
  }
 
  if (error) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-4 bg-gray-50 px-6">
        <span className="text-4xl">📡</span>
        <p className="text-sm text-gray-500 text-center">{error}</p>
        <button
          onClick={onRefresh}
          className="px-5 py-2 rounded-xl bg-[#FDC700] text-black text-sm font-bold hover:bg-[#e6b300] transition-colors"
        >
          Try Again
        </button>
      </div>
    );
  }
 
  if (records.length === 0) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-3 bg-gray-50 text-gray-300">
        <CalendarEmptyIcon />
        <span className="text-sm text-gray-400">
          No records for {monthName} {year}
        </span>
      </div>
    );
  }
 
  return (
    <div
      className="flex-1 overflow-y-auto bg-gray-50 pb-8"
      style={{ scrollbarWidth: "none" }}
    >
      {/* Refreshing indicator — subtle yellow bar at top */}
      {refreshing && (
        <div className="h-1 bg-[#FDC700] animate-pulse mx-3 rounded-full mb-2 mt-1" />
      )}
 
      <div className="pt-2" />
      {records.map((item) => (
        <AttendanceItem key={item.id} item={item} />
      ))}
    </div>
  );
}